// extracted by mini-css-extract-plugin
export default {"container":"competition-info_container"};